import React, { useContext } from 'react';
import TreeItem from '@material-ui/lab/TreeItem';

import { StructMapData } from './struct-map-types';
import { StructMapItemNode } from './struct-map-item-node';
import { StructMapItemLeaf } from './struct-map-item-leaf';
import { StructMapCtx } from './struct-map-ctx';
import { ArchivalUnitCopy } from '../../types';

interface Props {
  parent?: StructMapData;
  archivalEntity: ArchivalUnitCopy;
  data: StructMapData;
}

export function StructMapItem({ parent, archivalEntity, data }: Props) {
  const { nodeLabelMapper, leafLabelMapper, expandedNodes } = useContext(
    StructMapCtx
  );

  const isFolder = !data.fileRef;

  /**
   * Empty array if node === LEAF.
   */
  const subDivisions = data?.subDivisions ?? [];

  /**
   * Pick NODE / LEAF depending on children existence.
   */
  const Item = isFolder ? StructMapItemNode : StructMapItemLeaf;

  const isOpenNode = expandedNodes.find((n) => n === data.id);

  /**
   * Pick label mapper.
   */
  const label = isFolder
    ? nodeLabelMapper(data, archivalEntity, !!isOpenNode)
    : leafLabelMapper(data);

  return (
    <TreeItem
      nodeId={data.id!}
      label={<Item data={data} label={label} parent={parent} />}
    >
      {subDivisions.map((d) => (
        <StructMapItem
          key={d.id}
          data={d}
          parent={data}
          archivalEntity={archivalEntity}
        />
      ))}
    </TreeItem>
  );
}
